import { mediaUrl } from "@/lib/portalApi";

const initials = (n) => (n || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

// Shared member avatar — renders the uploaded photo, or falls back to initials.
export default function Avatar({ name, avatar, size = 36, className = "", testid }) {
  const style = { width: size, height: size };
  if (avatar) {
    return (
      <img data-testid={testid} src={mediaUrl(avatar)} alt={name || "Member"} style={style}
        className={`rounded-full object-cover shrink-0 bg-[#EAE3D9] ${className}`} />
    );
  }
  return (
    <span data-testid={testid} style={{ ...style, fontSize: Math.round(size * 0.36) }}
      className={`rounded-full bg-[#EAE3D9] text-[#A9724E] flex items-center justify-center font-serif-display shrink-0 ${className}`}>
      {initials(name)}
    </span>
  );
}
